(() => {
  const initialize = (root) => {
    if (!root || root.dataset.swStoreInitialized === 'true') return;

    root.dataset.swStoreInitialized = 'true';
    root.querySelectorAll('[data-sw-tour]').forEach((viewer) => {
      const button = viewer.querySelector('[data-sw-tour-start]');
      const template = viewer.querySelector('[data-sw-tour-template]');
      if (!button || !template) return;

      button.addEventListener('click', () => {
        viewer.append(template.content.cloneNode(true));
        viewer.querySelector('[data-sw-tour-placeholder]').remove();
        viewer.querySelector('iframe').focus({ preventScroll: true });
      }, { once: true });
    });
    const items = [...root.querySelectorAll('[data-sw-reveal]')];

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduceMotion) {
      root.querySelectorAll('video[autoplay]').forEach((video) => {
        video.autoplay = false;
        video.pause();
      });
    }

    if (reduceMotion || !('IntersectionObserver' in window)) {
      items.forEach((item) => item.classList.add('is-visible'));
      return;
    }

    root.classList.add('is-ready');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    items.forEach((item) => observer.observe(item));
  };

  document.querySelectorAll('[data-sw-store]').forEach(initialize);

  document.addEventListener('shopify:section:load', (event) => {
    initialize(event.target.querySelector('[data-sw-store]'));
  });
})();
